import React from 'react';
import icWarning from 'assets/svg/ic_warning_V2.svg';
import styles from './styles.module.scss';
import Modal from '@profile/src/Components/PopupModal_V2';
import { getPreferredWalletProviderName } from '@profile/src/utils/session';
import Button from '@profile/src/Components/Button_V2';

const WarningWrongAddressModal = ({
  onClose
}) => {
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icWarning
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "Wrong wallet address")), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, /*#__PURE__*/React.createElement("span", null, `It looks like you're using an address different than the registered one.
        Please check your wallet address in ${getPreferredWalletProviderName()} and try again.`)), /*#__PURE__*/React.createElement(Button, {
    title: "OK",
    onClick: onClose
  }));
};

export default WarningWrongAddressModal;